// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + ".b6bde7656947586f6bf0aa1fc9ff5428.js";
};